import { faCog } from '@fortawesome/pro-duotone-svg-icons';

import { Permissions } from '@cloud-wave/neon-common-lib';

import MyLocationForm from 'lib/common/contexts/AgentPreferenceContext/MyLocationModal/MyLocationForm';
import { useLogStreamContext } from 'lib/common/contexts/LogStreamContext';
import { usePermissionsContext } from 'lib/common/contexts/PermissionsContext';
import { usePreferencesContext } from 'lib/common/contexts/PreferencesContext';
import { useSoftphoneModalContext } from 'lib/common/contexts/SoftphoneModalContext';
import { useLayout } from 'lib/common/contexts/layout/LayoutContext';

import { BadgeTypes } from 'lib/common/components/Badge/Badge';
import Checkbox from 'lib/common/components/atoms/Checkbox';
import PreferenceSectionContainer from 'lib/common/components/molecules/Preferences/components/PreferenceSectionContainer';

import PreferencesButton from '../PreferencesButton';

const PreferencesGeneral = () => {
  const {
    state: { enhancedLoggingEnabled },
    actions: { setEnhancedLoggingEnabled },
  } = usePreferencesContext();

  const { hasPermission } = usePermissionsContext();
  const { isSoftphone } = useLayout();

  const {
    state: { logStreamingEnabled },
  } = useLogStreamContext();

  const {
    actions: { openModal, closeModal },
  } = useSoftphoneModalContext();

  return (
    <PreferenceSectionContainer icon={faCog} title={'General'}>
      {isSoftphone && hasPermission({ type: 'tenant', permission: Permissions.ENHANCED_EMERGENCY_CALLING }) && (
        <PreferencesButton
          title="Emergency Call Information"
          subtitle="Enhance your outbound emergency calls with precise location information."
          onClick={() =>
            openModal({
              title: 'Emergency Call Information',
              content: <MyLocationForm editMode closeModal={closeModal} />,
              subtitle:
                'Your administrator has enabled enhanced emergency calling to include additional data in outbound emergency calls.',
            })
          }
        />
      )}

      <Checkbox
        id="enhanced-logging-checkbox"
        titleBadgeProps={
          logStreamingEnabled
            ? {
                label: 'Administrator Managed',
                type: BadgeTypes.NEUTRAL,
              }
            : undefined
        }
        label="Enhanced Logging"
        disabled={logStreamingEnabled}
        checked={enhancedLoggingEnabled}
        reverse
        onChange={setEnhancedLoggingEnabled}
        subtitle="Stores additional logs and performance metrics in your log file which can be useful when trying to resolve issues."
      />
    </PreferenceSectionContainer>
  );
};

export default PreferencesGeneral;
